export default "__VITE_ASSET__B_gjWruK__"